export default __webpack_public_path__ + "static/media/pPlaceholder.5325d5b6.png";